//该JS用于创建VUEX的STORE
import Vuex from "vuex"
import Vue from 'vue'

import userOptions from "./userOpt"
import systemOptions from "./systemOpt"
import locationsOptions from "./locationOpt"
//创建SOTRE之前必须先引用VUEX否则报错
Vue.use(Vuex)

//创建并暴露store
export default new Vuex.Store({
  modules:{
    userAbout:userOptions,
    systemAbout:systemOptions,
    loacationAbout:locationsOptions,
  }
})